export { default as AccountBalanceIcon } from '@material-symbols/svg-400/outlined/account_balance.svg';
export { default as AddIcon } from '@/assets/icons/add.svg';
export { default as BackIcon } from '@/assets/icons/arrow_back.svg';
export { default as ArrowRightIcon } from '@/assets/icons/arrow_right.svg';
export { default as ArticlePersonIcon } from '@/assets/icons/article_person.svg';
export { default as DeleteForeverIcon } from '@/assets/icons/delete_forever.svg';
export { default as DraftsIcon } from '@/assets/icons/drafts.svg';
export { default as FamilyHomeIcon } from '@/assets/icons/family_home.svg';
export { default as GavelIcon } from '@/assets/icons/gavel.svg';
export { default as InfoIcon } from '@/assets/icons/info.svg';
export { default as KeyIcon } from '@/assets/icons/key.svg';
export { default as LogoutIcon } from '@/assets/icons/logout.svg';
export { default as NotificationsIcon } from '@/assets/icons/notifications.svg';
export { default as RecordVoiceOverIcon } from '@/assets/icons/record_voice_over.svg';
export { default as SupportIcon } from '@/assets/icons/support.svg';

// Todo: replace icons above with icons from material-symbols/svg-400 (if possible)

// SVG images
export { default as ErrorSlogan } from '@/assets/images/error_slogan.svg';
export { default as LoginSlogan } from '@/assets/images/login_slogan.svg';
export { default as SpeechBubbleCheckedImage } from '@/assets/images/speech_bubble.svg';

export { default as PeopleBackground } from '@/assets/images/people_background.png';

export { default as AppName } from '@/assets/images/app_name.svg';
export { default as FeedEmpty } from '@/assets/images/feed_empty.svg';
export { default as FeedEmptyAction } from '@/assets/images/feed_empty_action.svg';
export { default as FeedEnd } from '@/assets/images/feed_end.svg';

// PNG images

// HTML
export { default as MAP_RESOURCE } from '@/assets/html/map.html';

// Local SVG icons
export { default as StartIcon } from '@/assets/icons/start_icon.svg';

// Library SVG icons
export { default as AddAPhoto } from '@material-symbols/svg-400/outlined/add_a_photo.svg';
export { default as AddCircleIcon } from '@material-symbols/svg-400/outlined/add_circle.svg';
export { default as ArrowBackIcon } from '@material-symbols/svg-400/outlined/arrow_back.svg';
export { default as ArrowBackIosIcon } from '@material-symbols/svg-400/outlined/arrow_back_ios.svg';
export { default as ArrowForwardIcon } from '@material-symbols/svg-400/outlined/arrow_forward.svg';
export { default as ArrowForwardIosIcon } from '@material-symbols/svg-400/outlined/arrow_forward_ios.svg';
export { default as ArrowInsertIcon } from '@material-symbols/svg-400/outlined/arrow_insert.svg';
export { default as LeftIcon } from '@material-symbols/svg-400/outlined/arrow_left.svg';
export { default as ArrowOutwardIcon } from '@material-symbols/svg-400/outlined/arrow_outward.svg';
export { default as RightIcon } from '@material-symbols/svg-400/outlined/arrow_right.svg';
export { default as MoveIcon } from '@material-symbols/svg-400/outlined/arrows_output.svg';
export { default as AttachmentIcon } from '@material-symbols/svg-400/outlined/attach_file.svg';
export { default as BarChartIcon } from '@material-symbols/svg-400/outlined/bar_chart.svg';
export { default as BlockIcon } from '@material-symbols/svg-400/outlined/block.svg';
export { default as NewsItemIcon } from '@material-symbols/svg-400/outlined/breaking_news.svg';
export { default as BrushIcon } from '@material-symbols/svg-400/outlined/brush.svg';
export { default as CalendarIcon } from '@material-symbols/svg-400/outlined/calendar_month.svg';
export { default as CallIcon } from '@material-symbols/svg-400/outlined/call.svg';
export { default as WebIcon } from '@material-symbols/svg-400/outlined/captive_portal.svg';
export { default as ChatBubbleIcon } from '@material-symbols/svg-400/outlined/chat_bubble.svg';
export { default as ChatIcon } from '@material-symbols/svg-400/outlined/chat.svg';
export { default as CheckIcon } from '@material-symbols/svg-400/outlined/check.svg';
export { default as CheckSmallIcon } from '@material-symbols/svg-400/outlined/check_small.svg';
export { default as ChevronRightIcon } from '@material-symbols/svg-400/outlined/chevron_right.svg';
export { default as CloseIcon } from '@material-symbols/svg-400/outlined/close_small.svg';
export { default as ContentCopyIcon } from '@material-symbols/svg-400/outlined/content_copy.svg';
export { default as DarkModeIcon } from '@material-symbols/svg-400/outlined/dark_mode.svg';
export { default as DeleteIcon } from '@material-symbols/svg-400/outlined/delete.svg';
export { default as GroupsIcon } from '@material-symbols/svg-400/outlined/groups.svg';
export { default as GridViewIcon } from '@material-symbols/svg-400/outlined/grid_view.svg';
export { default as DocumentIcon } from '@material-symbols/svg-400/outlined/docs.svg';
export { default as DragIcon } from '@material-symbols/svg-400/outlined/drag_indicator.svg';
export { default as FoldedHandsIcon } from '@material-symbols/svg-400/outlined/folded_hands.svg';
export { default as HandFilledIcon } from '@material-symbols/svg-400/outlined/eda-fill.svg';
export { default as HandIcon } from '@material-symbols/svg-400/outlined/eda.svg';
export { default as EditIcon } from '@material-symbols/svg-400/outlined/edit.svg';
export { default as EditLocationIcon } from '@material-symbols/svg-400/outlined/edit_location_alt.svg';
export { default as WinkingPersonIcon } from '@material-symbols/svg-400/outlined/emoji_people.svg';
export { default as ErrorIcon } from '@material-symbols/svg-400/outlined/error.svg';
export { default as FavoriteFilledIcon } from '@material-symbols/svg-400/outlined/favorite-fill.svg';
export { default as FavoriteIcon } from '@material-symbols/svg-400/outlined/favorite.svg';
export { default as FeedbackIcon } from '@material-symbols/svg-400/outlined/feedback.svg';
export { default as ForumIcon } from '@material-symbols/svg-400/outlined/forum.svg';
export { default as PodcastsIcon } from '@material-symbols/svg-400/outlined/podcasts.svg';
export { default as SchoolIcon } from '@material-symbols/svg-400/outlined/school.svg';
export { default as PopulationIcon } from '@material-symbols/svg-400/outlined/groups.svg';
export { default as PollIcon } from '@material-symbols/svg-400/outlined/insert_chart.svg';
export { default as Inventory2Icon } from '@material-symbols/svg-400/outlined/inventory_2.svg';
export { default as DownIcon } from '@material-symbols/svg-400/outlined/keyboard_arrow_down.svg';
export { default as LanguageIcon } from '@material-symbols/svg-400/outlined/language.svg';
export { default as LinkIcon } from '@material-symbols/svg-400/outlined/link.svg';
export { default as LocationIcon } from '@material-symbols/svg-400/outlined/location_on.svg';
export { default as LockIcon } from '@material-symbols/svg-400/outlined/lock.svg';
export { default as LockClockIcon } from '@material-symbols/svg-400/outlined/lock_clock.svg';
export { default as LockOpenIcon } from '@material-symbols/svg-400/outlined/lock_open_right.svg';
export { default as LockResetIcon } from '@material-symbols/svg-400/outlined/lock_reset.svg';
export { default as MailIcon } from '@material-symbols/svg-400/outlined/mail.svg';
export { default as MenuBookIcon } from '@material-symbols/svg-400/outlined/menu_book.svg';
export { default as MoreHorizontalIcon } from '@material-symbols/svg-400/outlined/more_horiz.svg';
export { default as MoreVerticalIcon } from '@material-symbols/svg-400/outlined/more_vert.svg';
export { default as MyLocationIcon } from '@material-symbols/svg-400/outlined/my_location.svg';
export { default as NewspaperIcon } from '@material-symbols/svg-400/outlined/newspaper.svg';
export { default as PersonIcon } from '@material-symbols/svg-400/outlined/person.svg';
export { default as PersonAddIcon } from '@material-symbols/svg-400/outlined/person_add.svg';
export { default as PhotoIcon } from '@material-symbols/svg-400/outlined/photo.svg';
export { default as BrokenImageIcon } from '@material-symbols/svg-400/outlined/broken_image.svg';
export { default as CameraIcon } from '@material-symbols/svg-400/outlined/photo_camera.svg';
export { default as QuestionMarkIcon } from '@material-symbols/svg-400/outlined/question_mark.svg';
export { default as ParticipantsIcon } from '@material-symbols/svg-400/outlined/record_voice_over.svg';
export { default as NotVerifiedIcon } from '@material-symbols/svg-400/outlined/release_alert.svg';
export { default as SearchIcon } from '@material-symbols/svg-400/outlined/search.svg';
export { default as TagIcon } from '@material-symbols/svg-400/outlined/sell.svg';
export { default as TreesIcon } from '@/assets/icons/trees.svg';
export { default as SendIcon } from '@material-symbols/svg-400/outlined/send.svg';
export { default as SettingsIcon } from '@material-symbols/svg-400/outlined/settings.svg';
export { default as ShieldPersonIcon } from '@material-symbols/svg-400/outlined/shield_person.svg';
export { default as SuggestionIcon } from '@material-symbols/svg-400/outlined/shield_with_heart.svg';
export { default as StarFilledIcon } from '@material-symbols/svg-400/outlined/star-fill.svg';
export { default as StarIcon } from '@material-symbols/svg-400/outlined/star.svg';
export { default as MarketIcon } from '@material-symbols/svg-400/outlined/storefront.svg';
export { default as AreaIcon } from '@material-symbols/svg-400/outlined/straighten.svg';
export { default as SunnyIcon } from '@material-symbols/svg-400/outlined/sunny.svg';
export { default as SwapVertIcon } from '@material-symbols/svg-400/outlined/swap_vert.svg';
export { default as TodayIcon } from '@material-symbols/svg-400/outlined/today.svg';
export { default as TrophyIcon } from '@material-symbols/svg-400/outlined/trophy.svg';
export { default as ChatsIcon } from '@material-symbols/svg-400/outlined/tooltip_2.svg';
export { default as VerifiedIcon } from '@material-symbols/svg-400/outlined/verified.svg';
export { default as VerifiedFilledIcon } from '@material-symbols/svg-400/outlined/verified-fill.svg';
export { default as VisibilityIcon } from '@material-symbols/svg-400/outlined/visibility.svg';
export { default as VisibilityLockIcon } from '@material-symbols/svg-400/outlined/visibility_lock.svg';
export { default as VitalSignsTagIcon } from '@material-symbols/svg-400/outlined/vital_signs.svg';
export { default as GossipIcon } from '@material-symbols/svg-400/outlined/voice_selection.svg';
export { default as VolunteeringIcon } from '@material-symbols/svg-400/outlined/volunteer_activism.svg';
export { default as WavingHandIcon } from '@material-symbols/svg-400/outlined/waving_hand.svg';
